import { render } from "./weekly-activity-log.vue?vue&type=template&id=1388633d&ts=true"
import script from "./weekly-activity-log.vue?vue&type=script&lang=ts"
export * from "./weekly-activity-log.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__